import { Injectable } from '@angular/core';
import { TranslocoLoader } from '@jsverse/transloco';

/**
 * Used to indicate that a string is a translation key.
 * Could be used to check if a translation key is missing in the translation files.
 */
export type TranslationKey = string;

@Injectable({ providedIn: 'root' })
export class TranslocoSrcLoader implements TranslocoLoader {
    getTranslation(lang: string) {
        return import(`../../i18n/${lang}.json`);
    }
}
